import { MailIcon, PhoneIcon, QrcodeIcon } from '@heroicons/react/solid';
import React, { useState } from 'react';
import { UserType } from '../types/user';
import Button from './Button';
import MemberScanner from './MemberScanner';

interface UserInfoFlatProps {
  user?: UserType;
}

const UserInfoFlat: React.FC<UserInfoFlatProps> = ({ user }) => {
  const [showScanner, setShowScanner] = useState<boolean>(false);

  const scanQrCode = () => {
    setShowScanner(true);
  };

  return (
    <div className="ceas--ml-4 ceas--mt-4 ceas-flex ceas-justify-between ceas-items-center ceas-flex-wrap sm:ceas-flex-nowrap">
      <div className="ceas-ml-4 ceas-mt-4">
        <div className="ceas-flex ceas-items-center">
          <div className="ceas-flex-shrink-0">
            {user?.avatar_url && (
              <img
                className="ceas-h-12 ceas-w-12 ceas-rounded-full"
                src={user.avatar_url}
                alt="profile image"
              />
            )}
          </div>
          <div className="ceas-ml-4">
            <h3 className="ceas-text-lg ceas-leading-6 ceas-font-medium ceas-text-gray-900">
              {user?.name}
            </h3>
            <p className="ceas-text-sm ceas-text-gray-500">{user?.user_level}</p>
          </div>
        </div>
      </div>
      <div className="ceas-ml-4 ceas-mt-4 ceas-flex-shrink-0 ceas-flex ceas-space-x-1">
        <Button size="sm" onClick={scanQrCode}>
          <QrcodeIcon className="ceas--ml-1 ceas-mr-2 ceas-h-5 ceas-w-5 ceas-text-gray-400"/>
          <span>Scan QR Code</span>
        </Button>
        <Button size="sm">
          <PhoneIcon className="ceas--ml-1 ceas-mr-2 ceas-h-5 ceas-w-5 ceas-text-gray-400" />
          <span>Phone</span>
        </Button>
        <Button size="sm">
          <MailIcon className="ceas--ml-1 ceas-mr-2 ceas-h-5 ceas-w-5 ceas-text-gray-400" />
          <span>Email</span>
        </Button>

        <MemberScanner open={showScanner} setOpen={setShowScanner} />
      </div>
    </div>
  );
};

export default UserInfoFlat;
